// <s-grid-columns> lets shoppers choose how many product cards sit in a row.
// Buttons inside call it with command="--columns" and a data-columns value; the choice is
// stored per screen size (data-small below 1024px, data-large from 1024px) and remembered in
// localStorage. The grid reads the data attributes through group-data utilities, so filter
// and pagination re-renders of the grid keep the chosen layout.
const STORAGE_KEY = 'alqalam:grid-columns';
const LARGE_QUERY = '(min-width: 1024px)';

class GridColumns extends HTMLElement {
  #media = null;
  #onCommand = (event) => {
    if (event.command !== '--columns') return;
    const value = event.source?.dataset.columns;
    if (!value) return;
    this.#set(this.#media.matches ? 'large' : 'small', value);
  };
  #onMediaChange = () => this.#syncPressed();

  connectedCallback() {
    this.#media = window.matchMedia(LARGE_QUERY);
    const saved = this.#read();
    if (saved.small) this.dataset.small = saved.small;
    if (saved.large) this.dataset.large = saved.large;
    this.addEventListener('command', this.#onCommand);
    this.#media.addEventListener('change', this.#onMediaChange);
    this.#syncPressed();
  }

  disconnectedCallback() {
    this.removeEventListener('command', this.#onCommand);
    this.#media?.removeEventListener('change', this.#onMediaChange);
  }

  #set(size, value) {
    this.dataset[size] = value;
    const saved = this.#read();
    saved[size] = value;
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(saved));
    } catch {
      // Storage can be unavailable (private mode); the choice still applies to this visit.
    }
    this.#syncPressed();
  }

  #read() {
    try {
      return JSON.parse(localStorage.getItem(STORAGE_KEY) || '{}') || {};
    } catch {
      return {};
    }
  }

  #syncPressed() {
    const size = this.#media?.matches ? 'large' : 'small';
    const current = this.dataset[size];
    for (const button of this.querySelectorAll('button[data-columns]')) {
      button.setAttribute('aria-pressed', String(button.dataset.columns === current));
    }
  }
}

if (!customElements.get('s-grid-columns')) {
  customElements.define('s-grid-columns', GridColumns);
}
